import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Fact from './Fact';
import u from './FactUnderline.css';

function HoC(props) {
  return (
    <Fact id="bidra" title="Bidra till matglädje" {...props}>
      <p>
        {`
          Vi vill på ett positivt och inspirerande sätt hjälpa konsumenterna
          att välja rätt och Livsmedelsverkets kostråd är utformade för att
          skapa matglädje. När du väljer att omformulera råden är det viktigt
          att du behåller en positiv ton och känslan av att mat är förknippat
          med glädje. Du bör inte ställa olika livsmedel mot varandra. Lyft
          snarare fram och fokusera på fördelarna med dina produkter än att
          prata negativt om andras.
        `}
      </p>
      <p>
        {`
          Låt dig inte begränsas av bara
        `}
        <span className={u.root}>{'ett'}</span>{' '}
        {`kostråd. Kommunikation av flera
          kostråd kan bidra till en helhetssyn på bra matvanor.
        `}
      </p>
    </Fact>
  );
}

export default withStyles(u)(HoC);



// WEBPACK FOOTER //
// ./src/components/Fact/FactBidraTillMatgladje.js